import { render } from "./StretchToPage.vue?vue&type=template&id=506129c3"
import script from "./StretchToPage.vue?vue&type=script&lang=js"
export * from "./StretchToPage.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/StretchToPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "506129c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('506129c3', __exports__)) {
    api.reload('506129c3', __exports__)
  }
  
  module.hot.accept("./StretchToPage.vue?vue&type=template&id=506129c3", () => {
    api.rerender('506129c3', render)
  })

}


export default __exports__